import { InjectionToken, Signal, WritableSignal } from '@angular/core';
import { dsDtos, dsEnums } from '@vectronic/openApi-admin';
import { Observable } from 'rxjs';

export interface IScheduleTemplatesProviderService {
  searchFilter: WritableSignal<dsDtos.SearchScheduleTemplateAdmin>;
  isLoading: Signal<boolean>;
  templates: Signal<dsDtos.ScheduleTemplateAdmin[] | dsDtos.ScheduleTemplateCustomer[] | undefined>;
  userAccounts: Signal<{ item: number; label: string; email?: string }[]>;

  refresh(
    searchScheduleTemplateAdmin?: dsDtos.SearchScheduleTemplateAdmin,
  ): Observable<dsDtos.ScheduleTemplateAdmin[] | dsDtos.ScheduleTemplateCustomer[]>;
  setScheduleType(scheduleType: dsEnums.ScheduleType): void;
  setTemplateName(templateName: string): void;
  setUserIds(userIds: number[]): void;
  resetFilter(): void;
  add(
    template: dsDtos.AddScheduleTemplateAdmin | dsDtos.AddScheduleTemplateCustomer,
  ): Observable<dsDtos.ScheduleTemplateAdmin[] | dsDtos.ScheduleTemplateCustomer[]>;
  edit(
    template: dsDtos.EditScheduleTemplateAdmin | dsDtos.EditScheduleTemplateCustomer,
  ): Observable<dsDtos.ScheduleTemplateAdmin[] | dsDtos.ScheduleTemplateCustomer[]>;
  delete(
    id: string,
  ): Observable<dsDtos.ScheduleTemplateAdmin[] | dsDtos.ScheduleTemplateCustomer[]>;
  fromXmlString(
    scheduleType: dsEnums.ScheduleType,
    xmlStrings: string[],
    confirmDefaultSkipCountIsNotSupported?: boolean,
  ): Observable<dsDtos.SingleSchedule>;
}

export const ScheduleTemplatesProviderService =
  new InjectionToken<IScheduleTemplatesProviderService>('ScheduleTemplatesProviderService');
